import React, { PropTypes, Component } from 'react'

import './AddressFormFields.scss'
import InputControl from 'components/InputControl'

class AddressFormFields extends Component {
  constructor (props) {
    super(props)
    const inputs = {
      street: {
        required: true,
        label: 'Calle',
        meta: {
          active: false,
          touched: false,
          error: props.error.street
        }
      },
      number: {
        required: true,
        label: 'Exterior',
        meta: {
          active: false,
          touched: false,
          error: props.error.number
        }
      },
      interiorNumber: {
        required: false,
        label: 'Interior',
        meta: {
          active: false,
          touched: false,
          error: props.error.interiorNumber
        }
      },
      neighborhood: {
        required: true,
        label: 'Colonia',
        meta: {
          active: false,
          touched: false,
          error: props.error.neighborhood
        }
      },
      city: {
        required: true,
        label: 'Delegación',
        meta: {
          active: false,
          touched: false,
          error: props.error.city
        }
      },
      state: {
        required: true,
        label: 'Estado',
        meta: {
          active: false,
          touched: false,
          error: props.error.state
        }
      }
    }
    this.state = {
      inputs
    }
    this.onChange = this.onChange.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  onChange (e) {
    const { name: fieldName, value } = e.target
    this.updateAddress(fieldName, value)
  }

  onFocus (e) {
    const { name: inputName } = e.target
    const { inputs } = this.state

    const input = inputs[inputName]
    input.meta.active = true

    const updatedInputs = Object.assign({}, inputs, {[inputName]: input})
    this.setState({ inputs: updatedInputs })
  }

  onBlur (e) {
    const { name: inputName } = e.target
    const { inputs } = this.state

    const input = inputs[inputName]
    input.meta.active = false
    input.meta.touched = true

    const updatedInputs = Object.assign({}, inputs, {[inputName]: input})
    this.setState({ inputs: updatedInputs })
  }

  updateAddress (fieldName, value) {
    this.props.onChange({
      [fieldName]: value
    })
  }

  componentWillReceiveProps (nextProps) {
    this.handleErrors(nextProps)
  }

  handleErrors ({error: errors, touched}) {
    errors = errors || {}

    const inputs = this.state.inputs
    Object.keys(inputs).forEach(inputName => {
      const input = inputs[inputName]

      if (inputName in errors) {
        input.meta.error = errors[inputName]
      } else {
        delete input.meta.error
      }

      const userTouchedTheInput = input.meta.touched
      input.meta.touched = userTouchedTheInput ? input.meta.touched : touched
    })

    this.setState({ inputs })
  }

  createInputControl (name, label, meta) {
    return (
      <InputControl
        className={`AddressFormFields-${name}Field`}
        input={{
          name,
          value: this.props.values[name],
          onChange: this.onChange,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        }}
        meta={meta}
        type='text'
        label={label}
        key={name}
        />
    )
  }

  render () {
    const { inputs } = this.state

    const formFields = Object.keys(inputs).map(inputName => {
      const {
        label,
        meta
      } = inputs[inputName]
      return this.createInputControl(inputName, label, meta)
    })

    return (
      <div className='AddressFormFields'>
        {formFields}
      </div>
    )
  }
}

AddressFormFields.displayName = 'AddressFormFields'
AddressFormFields.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.object,
  touched: PropTypes.bool.isRequired
}

export default AddressFormFields



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/screens/ServiceAddress/components/AddressForm/components/AddressFormFields/AddressFormFields.js